import { ModelAspectRatio } from "../../../Models/devices";

export default class SizeHandler {
  private readonly HEADER_HEIGHT = 48;
  private readonly aspectRatio: number = 0;
  private readonly ASPECT_RATIO_4_3 = 1.32352; // ~4:3 based off camera's stream resolution
  private readonly ASPECT_RATIO_16_9 = 1.764706; // ~16:9 based off camera's stream resolution
  private readonly HORIZONTAL_MARGIN = 8; // Reduces video dimensions slightly to avoid scrollbars
  private readonly defaultBarHeight = 20;
  private readonly defaultVideoHeight =
    window.innerHeight - this.HORIZONTAL_MARGIN - this.defaultBarHeight;
  private readonly defaultVideoWidth = this.defaultVideoHeight * this.ASPECT_RATIO_4_3;
  videoWidth: number;
  videoHeight: number;

  constructor(modelAspectRatio: ModelAspectRatio = ModelAspectRatio.AR4_3) {
    switch (modelAspectRatio) {
      case ModelAspectRatio.AR1_1:
        this.aspectRatio = 1.0;
        break;
      case ModelAspectRatio.AR16_9:
        this.aspectRatio = this.ASPECT_RATIO_16_9;
        break;
      default:
        this.aspectRatio = this.ASPECT_RATIO_4_3;
        break;
    }

    this.defaultVideoWidth = this.defaultVideoHeight * this.aspectRatio;
    this.videoWidth = this.defaultVideoWidth;
    this.videoHeight = this.defaultVideoHeight;
  }

  resizeHandler(
    videoElement: HTMLVideoElement | null,
    controlBarElement: HTMLVideoElement | null,
    windowWidth: number,
    windowHeight: number
  ) {
    if (!videoElement || !controlBarElement) {
      return;
    }
    const controlBarHeight = controlBarElement.clientHeight;
    const calculatedVideoHeightForFullWidthVideo = windowWidth / this.aspectRatio;
    const availableHeightForVideo = windowHeight - controlBarHeight - this.HEADER_HEIGHT;
    this.videoHeight =
      availableHeightForVideo > calculatedVideoHeightForFullWidthVideo
        ? calculatedVideoHeightForFullWidthVideo - this.HORIZONTAL_MARGIN
        : availableHeightForVideo - this.HORIZONTAL_MARGIN;
    this.videoWidth = this.videoHeight * this.aspectRatio;
  }
}
